module.exports = __webpack_public_path__ + "static/media/unilogo.92e78d2e.svg";